import {
  createEditorPlatformContextError,
  EditorPlatformContextErrorCode,
} from '../errors';

const WAIT_INJECTED_TIMEOUT = 200;
const WAIT_INJECTED_RETRY_COUNT = 50;

export class ContextInjectionStatus {
  injectionUUID: string;
  injectionUUID_Deprecated: string;

  constructor(uuid: string) {
    this.injectionUUID_Deprecated = `__${uuid}_CONTEXT_INJECTION_STATUS_KEY`;
    this.injectionUUID = `__${uuid}_CONTEXT_INJECTION_STATUS_KEY#0.1`;

    const promise = this.#getGlobalInjectionPromise();

    if (!promise) {
      this.#createGlobalInjectionPromise();
    }
  }

  #getGlobalInjectionPromise() {
    // @ts-expect-error xxx
    const ref = globalThis[this.injectionUUID];
    return ref?.promise;
  }

  #createGlobalInjectionPromise() {
    let _resolve;

    const promise = new Promise<void>((resolve) => {
      _resolve = resolve;
    });

    // @ts-expect-error xxx
    globalThis[this.injectionUUID] = {
      promise,
      resolve: _resolve,
    };

    /**
     * as soon as new latest-version promise is created
     * override existing deprecated promise and resolve it
     * as soon as latest is resolved
     */
    // @ts-expect-error xxx
    globalThis[this.injectionUUID_Deprecated] = new Promise((resolve) => {
      promise.then(resolve);
    });
  }

  resolveInjected() {
    // @ts-expect-error xxx
    globalThis[this.injectionUUID]?.resolve();
  }

  waitInjected() {
    return new Promise<void>((resolve, reject) => {
      let injected = false;
      let timeoutId: ReturnType<typeof setTimeout>;
      let retryCount = 0;

      const timeout = () => {
        if (injected) {
          return;
        }

        timeoutId = setTimeout(() => {
          retryCount++;

          if (retryCount < WAIT_INJECTED_RETRY_COUNT) {
            /**
             * just log that we are re-trying to connect (each 2 sec+-)
             */
            if (retryCount % 10 === 0) {
              console.log(
                createEditorPlatformContextError(
                  EditorPlatformContextErrorCode.IncorrectEnvironment,
                  'contexts are not resolved, still re-trying',
                ).withMessage(`try number ${retryCount}`).message,
              );
            }

            timeout();

            return;
          }

          if (!injected) {
            const error = createEditorPlatformContextError(
              EditorPlatformContextErrorCode.IncorrectEnvironment,
              'contexts are not resolved, threw by timeout',
            );

            reject(error);
          }
        }, WAIT_INJECTED_TIMEOUT);
      };

      timeout();

      this.#getGlobalInjectionPromise()?.then(() => {
        injected = true;
        clearTimeout(timeoutId);
        resolve();
      });
    });
  }
}
